'use client';

import { useCallback, useRef } from 'react';

export const DEFAULT_DEBOUNCE_DELAY = 500;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebouncedCallback = <T extends any[]>(
  callback: (...args: T) => Promise<void> | void,
  wait: number = DEFAULT_DEBOUNCE_DELAY,
) => {
  const timeout = useRef<NodeJS.Timeout | null>(null);

  return useCallback(
    (...args: T) => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }

      timeout.current = setTimeout(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        callback(...args);
      }, wait);
    },
    [callback, wait],
  );
};
